import { createContext } from 'react';

export const darkModeContext = createContext();
